import NavBar from "@/components/landing/NavBar";
import Hero from "@/components/landing/Hero";
import TrustMatrix from "@/components/landing/TrustMatrix";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import Gallery from "@/components/landing/Gallery";
import BeforeAfter from "@/components/landing/BeforeAfter";
import VideoShowcase from "@/components/landing/VideoShowcase";
import WhyChooseUs from "@/components/landing/WhyChooseUs";
import Testimonials from "@/components/landing/Testimonials";
import Blog from "@/components/landing/Blog";
import AwardBanner from "@/components/landing/AwardBanner";
import CtaBand from "@/components/landing/CtaBand";
import ContactFooter from "@/components/landing/ContactFooter";

const LandingPage = () => {
  return (
    <main data-testid="landing-page" className="bg-white text-green-950">
      <NavBar />
      <Hero />
      <AwardBanner />
      <TrustMatrix />
      <About />
      <Services />
      <Gallery />
      <BeforeAfter />
      <VideoShowcase />
      <WhyChooseUs />
      <Testimonials />
      <Blog />
      <CtaBand />
      <ContactFooter />
    </main>
  );
};

export default LandingPage;
